<template>
    <div class="">
        <flexible-content :value="template" />
    </div>
</template>

<script>
export default {
    props: ['template'],
}
</script>
